// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IRpcContext } from "@lib/messaging/rpc/IRpcContext";
import { RpcResult } from "@lib/messaging/rpc/RpcResult";

/**
 * Provides an API for handling incoming RPC requests.
 */
export interface IRpcServer<TRpcContext extends IRpcContext>
{
  invoke<T, E>(context: TRpcContext, method: string, args: any[], timeout: Optional<number>): RpcResult<T, E>;
  notify(context: TRpcContext, method: string, args: any[]): void;
}